import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Button } from '@mui/material';

var _excluded = ["pickerValue", "pickerState", "pickerEvents", "variant", "children", "disabled"];

var getDefaultPickerContent = function getDefaultPickerContent(value, state) {
  return "Choose File".concat(state.multiple ? "s" : "");
};

var FilePickerButton = function FilePickerButton(_ref) {
  var pickerValue = _ref.pickerValue,
      pickerState = _ref.pickerState,
      pickerEvents = _ref.pickerEvents,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "contained" : _ref$variant,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? getDefaultPickerContent : _ref$children,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    variant: variant,
    onClick: pickerEvents.onOpenDialog,
    disabled: disabled || pickerState.disabled
  }), typeof children === "function" ? children(pickerValue, pickerState, pickerEvents) : children);
};

var FilePickerButton$1 = FilePickerButton;

export { FilePickerButton$1 as default };
